export const inputs = [
  {
    name: 'text',
    id: 'text',
    type: 'text',
    label: 'Question*',
    placeholder: 'Example: Which appendix of the AFDP 3-85...',
  },
  {
    name: 'correctAnswer',
    id: 'correct-answer',
    type: 'text',
    label: 'Correct Answer*',
    placeholder: 'Example: Appendix A',
  },
  {
    name: 'incorrectAnswer1',
    id: 'incorrect-answer1',
    type: 'text',
    label: 'Incorrect Answer (optional)',
    placeholder: 'Example: Appendix D',
    hasAddButton: true,
  },
  {
    name: 'answerLocation',
    id: 'answer-location',
    type: 'text',
    label: 'Where does the answer come from?',
    placeholder: 'Example: AFDP-3-85 (DEC 2023) / CHAPTER 01',
  },
];
